export const isValidUsername = (str: string) => str && str.trim().length >= 2 && str.trim().length <= 20

export const isValidAccount = (str: string) => str && str.match(/^[A-Za-z0-9_-]{4,25}$/) !== null

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

export const isValidPhoneNumber = (str: string) => str.match(/^1\d{10}$/) !== null

export const isEmail = (str: string) => /^\w+@\w+\.[a-z]+$/.test(str)

// export const isName = (str: string) => /^[A-Za-z0-9_-][\u4E00-\u9FA5A-Za-z\s]+(·[\u4E00-\u9FA5A-Za-z]+)*$/.test(str)

export const isName = (str: string) => str && str.trim().length >= 2 && str.trim().length <= 10
